import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { Portal } from 'react-portal';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

import { getWindowState } from '../../../@shared/active_resize_listener/selectors';
import { DIMENSION_STATES } from '../../utils/dimension';

import './mobile_sub_navigation.scss';

export class MobileSubNavigation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoaded: false,
      open: false,
    };

    this.chooseButton = this.chooseButton.bind(this);
    this.closeDropdown = this.closeDropdown.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.toggleOpenDropdown = this.toggleOpenDropdown.bind(this);
  }

  componentWillMount() {
    document.addEventListener('mousedown', this.handleClick, false);
  }

  componentDidMount() {
    this.setState({ isLoaded: true });
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick, false);
  }

  handleClick(e) {
    if (!_.isEmpty(this.node) && !this.node.contains(e.target)) {
      this.setState({ open: false });
    }
  }

  closeDropdown() {
    this.setState({ open: false });
  }

  chooseButton(option) {
    const { history } = this.props;
    const pathname = _.get(this.props, 'location.pathname', '');
    const matchPath = pathname.match(option.regex);
    if (option.onClick) {
      return (
        <Button
          className={classnames('mobile-sub-nav__choose-button', { '-active': matchPath })}
          color="link"
          key={option.title}
          onClick={matchPath ? this.closeDropdown : option.onClick}
        >
          <span>{option.title}</span>
        </Button>
      );
    }

    return (
      <Button
        className={classnames('mobile-sub-nav__choose-button', { '-active': matchPath })}
        color="link"
        key={option.title}
        onClick={() => (matchPath ? this.closeDropdown() : history.push(option.path))}
      >
        <span>{option.title}</span>
      </Button>
    );
  }

  toggleOpenDropdown() {
    this.setState(prevState => ({ open: !prevState.open }));
  }

  render() {
    const {
      rightButtonClassName,
      rightButtonClick,
      rightButtonLabel,

      leftButtonClassName,
      leftButtonClick,
      leftButtonLabel,

      buttonChooseTitle,
      chooseOptions,
      hideChooseIcon,

      containerClassName,
      withPrevIcon,
      windowState,

      location,
    } = this.props;
    const { open, isLoaded } = this.state;

    const isMobile = windowState === DIMENSION_STATES.MOBILE;
    const pathname = _.get(location, 'pathname', '');
    const mobileSubNav = _.invoke(document, 'getElementById', 'mobile-sub-nav');
    let chooseTitle = buttonChooseTitle;

    if (buttonChooseTitle) {
      const activeOption = _.find(chooseOptions, option => pathname.match(option.regex));
      if (activeOption) {
        chooseTitle = activeOption.title;
      }
    }

    return (
      isMobile &&
      isLoaded &&
      !!mobileSubNav && (
        <Portal node={mobileSubNav}>
          <div
            className={classnames('mobile-sub-nav', containerClassName, {
              '-open': open,
            })}
          >
            {leftButtonLabel && (
              <Button
                color="link"
                className={classnames(
                  'mobile-sub-nav__button -left',
                  {
                    'mobile-sub-nav__icon icon-chevron-left': withPrevIcon,
                  },
                  leftButtonClassName,
                )}
                onClick={leftButtonClick}
              >
                {leftButtonLabel}
              </Button>
            )}

            {buttonChooseTitle && (
              <Fragment>
                <div
                  role="presentation"
                  className={classnames('mobile-sub-nav__choose-label', {
                    '-icon icon-chevron-bold-down-after': !hideChooseIcon,
                  })}
                  ref={node => {
                    this.node = node;
                  }}
                  onClick={this.toggleOpenDropdown}
                >
                  {chooseTitle}
                </div>

                {chooseOptions && (
                  <div className="mobile-sub-nav__choose-options">
                    {_.map(chooseOptions, option => this.chooseButton(option, pathname))}
                  </div>
                )}
              </Fragment>
            )}

            {rightButtonLabel && (
              <Button
                color="link"
                className={classnames('mobile-sub-nav__button -right', rightButtonClassName)}
                onClick={rightButtonClick}
              >
                {rightButtonLabel}
              </Button>
            )}
          </div>
        </Portal>
      )
    );
  }
}

MobileSubNavigation.propTypes = {
  buttonChooseTitle: PropTypes.string,
  chooseOptions: PropTypes.arrayOf(PropTypes.shape({})),
  containerClassName: PropTypes.string,
  hideChooseIcon: PropTypes.bool,
  history: PropTypes.shape({}),
  leftButtonClassName: PropTypes.string,
  leftButtonClick: PropTypes.func,
  leftButtonLabel: PropTypes.string,
  location: PropTypes.shape({}),
  rightButtonClassName: PropTypes.string,
  rightButtonClick: PropTypes.func,
  rightButtonLabel: PropTypes.string,
  windowState: PropTypes.string,
  withPrevIcon: PropTypes.bool,
};

MobileSubNavigation.defaultProps = {
  containerClassName: '',
  leftButtonClassName: '',
  leftButtonLabel: '',
  rightButtonClassName: '',
  rightButtonLabel: '',
  withPrevIcon: true,
};

const mapStateToProps = state => ({
  windowState: getWindowState(state),
});

const withConnect = connect(mapStateToProps);

export default compose(
  withRouter,
  withConnect,
)(MobileSubNavigation);
